import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "paperdoll-fill",
  "use": "paperdoll-fill-usage",
  "viewBox": "0 0 13 32",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 32\" id=\"paperdoll-fill\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 9H2c-2 0-2 2-2 2v8s0 2 3 2l1 10c0 1 2.5 1 2.5 1S9 32 9 31l1-10c3 0 3-2.254 3-2.254V11s0-2-2-2zM6.5 0C8.441 0 10 1.553 10 3.486A3.506 3.506 0 016.5 7 3.483 3.483 0 013 3.514 3.506 3.506 0 016.5 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol